import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import ConfirmButton from '../atoms/ConfirmButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openResendGochi,
    updateOpenResendGochi,
    cancelAction,
    resendGochiAction
  }) => {
    return (
      <Dialog
        open={openResendGochi}
        onClose={() => {
          updateOpenResendGochi(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ごちを再送信しますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ConfirmButton onClickAction={resendGochiAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
